import React, { useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Button, Col, Form } from "react-bootstrap";
import dayjs from "dayjs";
import { ThreeCircles } from "react-loader-spinner";
import { toast } from "react-toastify";
import { apiRequest } from "../../services";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faBriefcase,
  faIdCard,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import "./AddBeneficiary.css";

const AddBeneficiary = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const passedAccountName = location.state?.accountName;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const passedAccountId = location.state?.accountId;

  const subscriptionPackageId = location.state?.subscriptionPackageId;


  const userData = useSelector((state) => state.users);

  const clientDetails = userData?.users.clientDetails;
  console.log("clientDetails:", clientDetails);

  const [loading, setLoading] = useState(false);
  const [formAssured, setFormAssured] = useState({
    assuredSurName: clientDetails.lastName || "",

    assuredDateOfBirth: clientDetails.dateOfBirth
      ? dayjs(clientDetails.dateOfBirth, "DD/MM/YYYY").format("YYYY-MM-DD")
      : "",
    assuredFirstName: clientDetails.firstName || "",

    assuredCniNumber: clientDetails.cniNumber || "",
    assuredEmail: clientDetails.email || "",
    assuredPlaceOfBirth: "",
    assuredMsisdn: clientDetails.phoneNumber || "",
    assuredCniPlaceOfIssue: clientDetails.cniPlaceOfIssue || "",
    assuredCniIssueDate: clientDetails.cniIssueDate
      ? dayjs(clientDetails.cniIssueDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : "",
    assuredProfession: clientDetails.occupation || "",
    assuredAdresse: clientDetails.address || "",
    insurancePackageSubscriptionId: subscriptionPackageId,
    beneficiarySurName: "",
    beneficiaryFirstName: "",
    beneficiaryMsisdn: "237",
    beneficiaryDateOfBirth: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isUnderage, setIsUnderage] = useState(false);

  useEffect(() => {
    if (formAssured.assuredDateOfBirth) {
      const birthDate = dayjs(formAssured.assuredDateOfBirth);
      const age = dayjs().diff(birthDate, "year");
      setIsUnderage(age < 18);
    } else {
      setIsUnderage(false);
    }
  }, [formAssured.assuredDateOfBirth]);

  const resetForm = () => {
    setFormAssured({
      assuredSurName: "",
      assuredDateOfBirth: "",
      assuredFirstName: "",
      assuredCniNumber: "",
      assuredEmail: "",
      assuredPlaceOfBirth: "",
      assuredMsisdn: "",
      assuredCniPlaceOfIssue: "",
      assuredCniIssueDate: "",
      assuredProfession: "",
      assuredAdresse: "",
      beneficiarySurName: "",
      beneficiaryFirstName: "",
      beneficiaryMsisdn: "",
      beneficiaryDateOfBirth: "",
    });
    setFormErrors({});
  };

  const validateForm = (fieldName = null) => {
    const errors = { ...formErrors };

    const validateField = (name, value, required = true) => {
      if (required && !value) {
        errors[name] = t("requiredField");
      } else {
        delete errors[name];
      }
    };

    if (!fieldName || fieldName === "assuredSurName") {
      if (formAssured.assuredSurName) {
        if (formAssured.assuredSurName.length < 2) {
          errors.assuredSurName = t("minimumCharacters", { count: 2 });
        } else {
          delete errors.assuredSurName;
        }
      } else {
        errors.assuredSurName = t("requiredField");
      }
    }

    if (!fieldName || fieldName === "assuredMsisdn") {
      if (formAssured.assuredMsisdn) {
        if (!/^\d{12}$/.test(formAssured.assuredMsisdn)) {
          errors.assuredMsisdn = t("phoneNumberLength");
        } else {
          delete errors.assuredMsisdn;
        }
      } else {
        errors.assuredMsisdn = t("requiredField");
      }
    }

    if (!fieldName || fieldName === "assuredFirstName") {
      if (formAssured.assuredFirstName) {
        if (formAssured.assuredFirstName.length < 2) {
          errors.assuredFirstName = t("minimumCharacters", { count: 2 });
        } else {
          delete errors.assuredFirstName;
        }
      } else {
        errors.assuredFirstName = t("requiredField");
      }
    }

    if (!fieldName || fieldName === "assuredCniNumber") {
      validateField("assuredCniNumber", formAssured.assuredCniNumber);
    }

    if (!fieldName || fieldName === "assuredEmail") {
      if (formAssured.assuredEmail) {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formAssured.assuredEmail)) {
          errors.assuredEmail = t("invalidEmail");
        } else {
          delete errors.assuredEmail;
        }
      } else {
        errors.assuredEmail = t("requiredField");
      }
    }

    if (!fieldName || fieldName === "assuredCniPlaceOfIssue") {
      validateField(
        "assuredCniPlaceOfIssue",
        formAssured.assuredCniPlaceOfIssue
      );
    }

    if (!fieldName || fieldName === "assuredDateOfBirth") {
      validateField("assuredDateOfBirth", formAssured.assuredDateOfBirth);
    }

    if (!fieldName || fieldName === "assuredCniIssueDate") {
      validateField("assuredCniIssueDate", formAssured.assuredCniIssueDate);
    }

    if (!fieldName || fieldName === "assuredProfession") {
      validateField("assuredProfession", formAssured.assuredProfession);
    }

    if (!fieldName || fieldName === "assuredAdresse") {
      validateField("assuredAdresse", formAssured.assuredAdresse);
    }

    if (!fieldName || fieldName === "assuredPlaceOfBirth") {
      validateField("assuredPlaceOfBirth", formAssured.assuredPlaceOfBirth);
    }

    // Validate beneficiary fields as required
    if (!fieldName || fieldName === "beneficiarySurName") {
      if (formAssured.beneficiarySurName) {
        if (formAssured.beneficiarySurName.length < 2) {
          errors.beneficiarySurName = t("minimumCharacters", { count: 2 });
        } else {
          delete errors.beneficiarySurName;
        }
      } else {
        errors.beneficiarySurName = t("requiredField");
      }
    }

    if (!fieldName || fieldName === "beneficiaryFirstName") {
      if (formAssured.beneficiaryFirstName) {
        if (formAssured.beneficiaryFirstName.length < 2) {
          errors.beneficiaryFirstName = t("minimumCharacters", { count: 2 });
        } else {
          delete errors.beneficiaryFirstName;
        }
      } else {
        errors.beneficiaryFirstName = t("requiredField");
      }
    }

    if (!fieldName || fieldName === "beneficiaryMsisdn") {
      if (formAssured.beneficiaryMsisdn) {
        if (!/^\d{12}$/.test(formAssured.beneficiaryMsisdn)) {
          errors.beneficiaryMsisdn = t("phoneNumberLength");
        } else {
          delete errors.beneficiaryMsisdn;
        }
      } else {
        errors.beneficiaryMsisdn = t("requiredField");
      }
    }

    if (!fieldName || fieldName === "beneficiaryDateOfBirth") {
      validateField("beneficiaryDateOfBirth", formAssured.beneficiaryDateOfBirth);
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleBenefChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "beneficiaryMsisdn" && !value.startsWith("237")
      ? "237"
      : value;

    setFormAssured((prev) => ({
      ...prev,
      [name]: newValue,
    }));
    console.log(formAssured)
  };

  const handleConfirmAddAssured = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      const formDataWithIds = {
        ...formAssured,
        accountId: passedAccountId,
        clientId: userData?.clientDetails?.clientId,
        insuranceName: passedAccountName,
      };
      const requestData = {
        serviceReference: "ADD_CLIENT_BENEFICIARY",
        requestBody: JSON.stringify(formDataWithIds),
      };

      console.log("token ----> ", userData)

      const response = await apiRequest(
        "GATEWAY",
        "",
        "POST",
        requestData,
        userData.token,
        dispatch,
        navigate
      );
      if (response?.status === 200 && response.body.meta.statusCode === 200) {
        resetForm();
        toast.success(t("Benficiaryaddedsuccessfully"));
        navigate("/beneficiary");
      } else if (response?.body.meta.statusCode === 409) {
        toast.error("ifAffiled");
      } else {
        toast.error(response.body.errors || t("submissionFailed"));
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(t("submissionError"));
    } finally {
      if (!navigate.current) {
        setLoading(false);
      }
    }
  };

  const handleAssuredDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
    setFormAssured((prev) => ({
      ...prev,
      assuredDateOfBirth: formattedDate,
    }));
    // validateForm("assuredDateOfBirth");
  };

  const handleAssuredCniIssueDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
    setFormAssured((prev) => ({
      ...prev,
      assuredCniIssueDate: formattedDate,
    }));
    // validateForm("assuredCniIssueDate");
  };

  const handleBeneficiaryDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
    setFormAssured((prev) => ({
      ...prev,
      beneficiaryDateOfBirth: formattedDate,
    }));
    // validateForm("beneficiaryDateOfBirth");
  };

  return (
    <div>
      <div className="beneficiary">
        <div className="overlay-text">{t("assue")}</div>
      </div>
      <div className="cards p-3">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex">
            <h2 className="custom-title">
              <FontAwesomeIcon icon={faUser} className="me-2" />
              {t("assue")}
              <span className="client-id">
                ({userData?.users?.clientDetails?.clientId})
              </span>
            </h2>
          </div>
          <div className="d-flex">
            <Button
              className="back-button animate__animated animate__fadeIn"
              onClick={() => navigate("/beneficiary")}
            >
              <FontAwesomeIcon icon={faUser} className="me-2" />
              {t("Back")}
            </Button>
          </div>
        </div>

        <div className="border-top pb-2 mb-4 d-lg-flex justify-content-between align-items-center bg-white rounded p-1 animate__animated animate__fadeInUp">
          <div className="d-flex flex-column">
            <label
              htmlFor="searchInput"
              className="beneficiary-label fw-bold mb-2 text-success"
            >
              {t("beneficiaryInfo")}*
            </label>
          </div>
        </div>

        <div className="card p-4 animate__animated animate__fadeInUp">
          <h4 className="custom-title">
            <FontAwesomeIcon icon={faUser} className="me-2" />
            {t("assureinfo")}
          </h4>
          <Form className="row g-3">
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredSurName" className="form-label">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  {t("nom")} :
                </label>
                <input
                  type="text"
                  className={`form-control p-2 ${formErrors.assuredSurName ? "is-invalid" : ""
                    }`}
                  id="assuredSurName"
                  name="assuredSurName"
                  placeholder={t("namePlaceholder")}
                  value={formAssured.assuredSurName}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredSurName && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredSurName}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredMsisdn" className="form-label">
                  <FontAwesomeIcon icon={faPhone} className="me-2" />
                  {t("phoneNumber")} :
                </label>
                <input
                  type="text"
                  className={`form-control p-2 ${formErrors.assuredMsisdn ? "is-invalid" : ""
                    }`}
                  id="assuredMsisdn"
                  name="assuredMsisdn"
                  placeholder={t("phoneNumberPlaceholder")}
                  value={formAssured.assuredMsisdn}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredMsisdn && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredMsisdn}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredFirstName" className="form-label">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  {t("SurName")} :
                </label>
                <input
                  type="text"
                  className={`form-control p-2 ${formErrors.assuredFirstName ? "is-invalid" : ""
                    }`}
                  id="assuredFirstName"
                  name="assuredFirstName"
                  placeholder={t("EnterSurName")}
                  value={formAssured.assuredFirstName}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredFirstName && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredFirstName}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredProfession" className="form-label">
                  <FontAwesomeIcon icon={faBriefcase} className="me-2" />
                  {t("Profession")} :
                </label>
                <input
                  type="text"
                  className={`form-control p-2 ${formErrors.assuredProfession ? "is-invalid" : ""
                    }`}
                  id="assuredProfession"
                  name="assuredProfession"
                  placeholder={t("assuredProfession")}
                  value={formAssured.assuredProfession}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredProfession && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredProfession}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredAdresse" className="form-label">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                  {t("Adresse")} :
                </label>
                <input
                  type="text"
                  className={`form-control p-2 ${formErrors.assuredAdresse ? "is-invalid" : ""
                    }`}
                  id="assuredAdresse"
                  name="assuredAdresse"
                  placeholder={t("assuredAdresse")}
                  value={formAssured.assuredAdresse}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredAdresse && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredAdresse}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredCniNumber" className="form-label">
                  <FontAwesomeIcon icon={faIdCard} className="me-2" />
                  {t("cni")} :
                </label>
                <input
                  type="text"
                  className={`form-control p-2 ${formErrors.assuredCniNumber ? "is-invalid" : ""
                    }`}
                  id="assuredCniNumber"
                  name="assuredCniNumber"
                  placeholder={t("idnumber")}
                  value={formAssured.assuredCniNumber}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredCniNumber && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredCniNumber}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredEmail" className="form-label">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                  {t("Email")} :
                </label>
                <input
                  type="email"
                  className={`form-control p-2 ${formErrors.assuredEmail ? "is-invalid" : ""
                    }`}
                  id="assuredEmail"
                  name="assuredEmail"
                  placeholder={t("enterEmail")}
                  value={formAssured.assuredEmail}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredEmail && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredEmail}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredCniPlaceOfIssue" className="form-label">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                  {t("cniPlaceOfIssue")} :
                </label>
                <input
                  type="text"
                  className={`form-control p-2 ${formErrors.assuredCniPlaceOfIssue ? "is-invalid" : ""
                    }`}
                  id="assuredCniPlaceOfIssue"
                  name="assuredCniPlaceOfIssue"
                  placeholder={t("enterIdPlaceOfIssue")}
                  value={formAssured.assuredCniPlaceOfIssue}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredCniPlaceOfIssue && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredCniPlaceOfIssue}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredDateOfBirth" className="form-label">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                  {t("dateOfBirth")} :
                </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={`form-control ${formErrors.beneficiaryDateOfBirth ? "is-invalid" : ""
                      }`}
                    value={formAssured.assuredDateOfBirth
                      ? dayjs(formAssured.assuredDateOfBirth)
                      : null}
                    onChange={handleAssuredDateChange}
                    format="YYYY-MM-DD"
                    disableFuture
                  />
                </LocalizationProvider>
                {formErrors.assuredDateOfBirth && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredDateOfBirth}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="6">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredCniIssueDate" className="form-label">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                  {t("idIssueDate")} :
                </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={`form-control ${formErrors.assuredCniIssueDate ? "is-invalid" : ""
                      }`}
                    value={
                      formAssured.assuredCniIssueDate
                        ? dayjs(formAssured.assuredCniIssueDate)
                        : null
                    }
                    onChange={handleAssuredCniIssueDateChange}
                    format="YYYY-MM-DD"
                    disableFuture
                  />
                </LocalizationProvider>
                {formErrors.assuredCniIssueDate && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredCniIssueDate}
                  </div>
                )}
              </div>
            </Col>
            <Col xl="12">
              <div className="mb-3 position-relative">
                <label htmlFor="assuredPlaceOfBirth" className="form-label">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                  {t("assuredPlaceOfBirth")} :
                </label>
                <input
                  type="text"
                  className={`form-control p-2 ${formErrors.assuredPlaceOfBirth ? "is-invalid" : ""
                    }`}
                  id="assuredPlaceOfBirth"
                  name="assuredPlaceOfBirth"
                  placeholder={t("enterIdPlaceOfBirth")}
                  value={formAssured.assuredPlaceOfBirth}
                  onChange={handleBenefChange}
                  required
                />
                {formErrors.assuredPlaceOfBirth && (
                  <div className="invalid-feedback animate__animated animate__shakeX">
                    {formErrors.assuredPlaceOfBirth}
                  </div>
                )}
              </div>
            </Col>
          </Form>

          <div className="mt-3 animate__animated animate__fadeInUp">
            <h4 className="custom-title">
              <FontAwesomeIcon icon={faUser} className="me-2" />
              {t("insuredInformation")} *
            </h4>
            <Form className="row g-3">
              <Col xl="4">
                <div className="mb-3 position-relative">
                  <label htmlFor="beneficiarySurName" className="form-label">
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    {t("nom")} :
                  </label>
                  <input
                    type="text"
                    className={`form-control p-2 ${formErrors.beneficiarySurName ? "is-invalid" : ""
                      }`}
                    id="beneficiarySurName"
                    name="beneficiarySurName"
                    placeholder={t("EnterBeneficiaryName")}
                    value={formAssured.beneficiarySurName}
                    onChange={handleBenefChange}
                    required
                  />
                  {formErrors.beneficiarySurName && (
                    <div className="invalid-feedback animate__animated animate__shakeX">
                      {formErrors.beneficiarySurName}
                    </div>
                  )}
                </div>
              </Col>
              <Col xl="4">
                <div className="mb-3 position-relative">
                  <label htmlFor="beneficiaryFirstName" className="form-label">
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    {t("SurName")} :
                  </label>
                  <input
                    type="text"
                    className={`form-control p-2 ${formErrors.beneficiaryFirstName ? "is-invalid" : ""
                      }`}
                    id="beneficiaryFirstName"
                    name="beneficiaryFirstName"
                    placeholder={t("EnterBeneficiarySurName")}
                    value={formAssured.beneficiaryFirstName}
                    onChange={handleBenefChange}
                    required
                  />
                  {formErrors.beneficiaryFirstName && (
                    <div className="invalid-feedback animate__animated animate__shakeX">
                      {formErrors.beneficiaryFirstName}
                    </div>
                  )}
                </div>
              </Col>
              <Col xl="4">
                <div className="mb-3 position-relative">
                  <label htmlFor="beneficiaryMsisdn" className="form-label">
                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                    {t("phoneNumber")} :
                  </label>
                  <input
                    type="text"
                    className={`form-control p-2 ${formErrors.beneficiaryMsisdn ? "is-invalid" : ""
                      }`}
                    id="beneficiaryMsisdn"
                    name="beneficiaryMsisdn"
                    placeholder={t("phoneNumberPlaceholder")}
                    value={formAssured.beneficiaryMsisdn}
                    onChange={handleBenefChange}
                    required
                  />
                  {formErrors.beneficiaryMsisdn && (
                    <div className="invalid-feedback animate__animated animate__shakeX">
                      {formErrors.beneficiaryMsisdn}
                    </div>
                  )}
                </div>
              </Col>
              <Col xl="12">
                <div className="mb-3 position-relative">
                  <label htmlFor="beneficiaryDateOfBirth" className="form-label">
                    <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                    {t("dateOfBirth")} :
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className={`form-control ${formErrors.beneficiaryDateOfBirth ? "is-invalid" : ""
                        }`
                      }
                      value={
                        formAssured.beneficiaryDateOfBirth
                          ? dayjs(formAssured.beneficiaryDateOfBirth)
                          : null
                      }
                      onChange={handleBeneficiaryDateChange}
                      format="YYYY-MM-DD"
                      disableFuture
                    />
                  </LocalizationProvider>
                  {formErrors.beneficiaryDateOfBirth && (
                    <div className="invalid-feedback animate__animated animate__shakeX">
                      {formErrors.beneficiaryDateOfBirth}
                    </div>
                  )}
                </div>
              </Col>
            </Form>
          </div>

          <div className="d-flex justify-content-end mt-4 flex-wrap">
            <Button
              variant="primary"
              className="custom-submit-btn"
              onClick={handleConfirmAddAssured}
              disabled={loading}
            >
              {loading ? (
                <ThreeCircles
                  height="20"
                  width="20"
                  color="white"
                  ariaLabel="loading"
                />
              ) : (
                <>
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  {t("confirmButton")}
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBeneficiary;
